import * as identity from '../utilities/identity';
import { browserHistory } from '../utilities/history';
import { logAppInsightsException } from '../utilities/logging';

const REFRESH_URL = '/Auth/Refresh';

export interface ApiResult<T> {
    success: boolean;
    error?: string;
    data?: T;
}

export interface LogInResponse {
    jwt: string;
    refreshToken: string;
}

const BASE_URL: string =
    process.env.REACT_APP_DEPLOY_ENV === 'prod'
        ? 'https://tour24-api-production.azurewebsites.net/api'
        : process.env.REACT_APP_DEPLOY_ENV === 'stage'
            ? 'https://tour24-api-staging.azurewebsites.net/api'
            : process.env.REACT_APP_DEPLOY_ENV === 'dev'
                ? 'https://tour24-api-development.azurewebsites.net/api'
                : process.env.REACT_APP_DEPLOY_ENV === 'local'
                    ? 'https://localhost:3000/api'
                    : 'https://localhost:30471/api';

const BRIVO_BASE_URL: string =
    process.env.REACT_APP_DEPLOY_ENV === 'prod'
        ? 'https://tour24-api-production.azurewebsites.net'
        : process.env.REACT_APP_DEPLOY_ENV === 'stage'
            ? 'https://tour24-api-staging.azurewebsites.net'
            : process.env.REACT_APP_DEPLOY_ENV === 'dev'
                ? 'https://tour24-api-development.azurewebsites.net'
                : process.env.REACT_APP_DEPLOY_ENV === 'local'
                    ? 'https://localhost:3000'
                    : 'https://localhost:30471';

const NEW_ADMIN_URL: string =
process.env.REACT_APP_DEPLOY_ENV === 'prod'
    ? 'https://explore.tour24.io'
        : 'https://explore-dev.tour24.io';

// New prospect web app (mobile-web) — target for properties piloting web tours.
const NEW_WEB_URL: string =
    process.env.REACT_APP_DEPLOY_ENV === 'prod'
        ? 'https://app.tour24.io'
        : process.env.REACT_APP_DEPLOY_ENV === 'stage'
            ? 'https://app-staging.tour24.io'
            : 'https://app-dev.tour24.io';


export const bmxConfig = process.env.REACT_APP_DEPLOY_ENV === 'prod' ?
    {
        "clientId": "c8a0f39572fdbee4a33e320ecb63011ad66eecda0600273955015dcd111ed180",
        "clientSecret": "1cacde46e5e81a3d58917741b3bc72f5254c4200c77e4ac9c02f97ee4073218a",
        "redirectUri": "https://app.tour24now.com/admin/manage",
        "responseType": "code",
        "env": "prod"
    } : process.env.REACT_APP_DEPLOY_ENV === 'stage' ?
        {
            "clientId": "c8a0f39572fdbee4a33e320ecb63011ad66eecda0600273955015dcd111ed180",
            "clientSecret": "1cacde46e5e81a3d58917741b3bc72f5254c4200c77e4ac9c02f97ee4073218a",
            "redirectUri": "https://tour24-ui-staging.azurewebsites.net/admin/manage",
            "responseType": "code",
            "env": "stage"
        }
        : process.env.REACT_APP_DEPLOY_ENV === 'dev' ?
            {
                "clientId": "c8a0f39572fdbee4a33e320ecb63011ad66eecda0600273955015dcd111ed180",
                "clientSecret": "1cacde46e5e81a3d58917741b3bc72f5254c4200c77e4ac9c02f97ee4073218a",
                "redirectUri": "urn:ietf:wg:oauth:2.0:oob",
                "responseType": "code",
                "env": "dev"
            }
            :
            {
                "clientId": "c8a0f39572fdbee4a33e320ecb63011ad66eecda0600273955015dcd111ed180",
                "clientSecret": "1cacde46e5e81a3d58917741b3bc72f5254c4200c77e4ac9c02f97ee4073218a",
                "redirectUri": "urn:ietf:wg:oauth:2.0:oob",
                "responseType": "code",
                "env": "local"
            }

            export const brivoConfig = process.env.REACT_APP_DEPLOY_ENV === 'prod' ?
            {
                "redirectUri": "https://app.tour24now.com/admin/manage",
                "tokenUrl" : "https://auth.brivo.com/oauth/token",
                "authUrl" : "https://auth.brivo.com/oauth/authorize",		
                "env": "prod"
            } : process.env.REACT_APP_DEPLOY_ENV === 'dev' ?
                    {
                        "redirectUri": "https://tour24-ui-development.azurewebsites.net/admin/manage",
                        "tokenUrl" : "https://auth.brivo.com/oauth/token",
                        "authUrl" : "https://auth.brivo.com/oauth/authorize",		
                        "env": "dev"
                    }
                    :
                    {
                        "redirectUri": "http://localhost:3000/admin/manage",
                        "tokenUrl" : "https://auth.brivo.com/oauth/token",
                        "authUrl" : "https://auth.brivo.com/oauth/authorize",		
                        "env": "local"
                    }

export const Urls = {
    BASE_URL
};

export const BrivoUrls = {
    BRIVO_BASE_URL
};
export const NewAdminUrls = {
NEW_ADMIN_URL
};
export const NewWebUrls = {
NEW_WEB_URL
};
// promise used during automatic token refresh attempts
let tokenRefreshPromise: Promise<void> | null = null;

function buildRequest(
    requestUrl: string,
    method: string = 'get',
    body?: any,
    leaveBody?: boolean
): Request {
    let headers: Headers = new Headers();

    headers.append('Accept', 'application/json');
    if (identity.isAuthenticated()) {
        headers.append('Authorization', `Bearer ${identity.getJwt()}`);
    }

    let content: string | Blob | undefined;

    if (leaveBody && body !== undefined) {
        content = body;
    } else if (body !== undefined) {
        content = JSON.stringify(body);
        headers.append('Content-Type', 'application/json');
    }

    return new Request(requestUrl, {
        method: method,
        body: content,
        headers: headers
    });
}

function updateRequestAuth(request: Request) {
    if (request.headers.has('Authorization')) {
        request.headers.delete('Authorization');
    }
    request.headers.append('Authorization', `Bearer ${identity.getJwt()}`);
    return request;
}

const kickToLogin = () => {
    if (identity.prospectLoggedIn()) {
        identity.clearToken();
        browserHistory.push('/prospect/login');
    } else {
        identity.clearToken();
        browserHistory.push('/login');
    }
};

export const refreshJwt = async () => {
    if (identity != null && identity.getRefreshToken() != '') {
        let refreshRequest = buildRequest(`${Urls.BASE_URL}${REFRESH_URL}`, 'post', {
            refreshToken: identity.getRefreshToken()
        });
        return fetch(refreshRequest)
            .then(response => checkStatus(response))
            .then(response => parseJSON<ApiResult<LogInResponse>>(response))
            .then(result => {
                if (result && result.data) {
                    identity.setTokens(result.data.jwt, result.data.refreshToken);
                    tokenRefreshPromise = null;
                } else {
                    throw new Error('Refresh token request failed');
                }
            })
            .catch(error => {
                kickToLogin();
                tokenRefreshPromise = null;
            });
    } else {
        kickToLogin();
        tokenRefreshPromise = null;
    }
};

async function checkTokenExpiration(
    request: Request,
    initialResponse: Response
): Promise<Response> {
    if (initialResponse.status === 401 && initialResponse.headers.has('www-authenticate')) {
        // Only try to refresh the JWT if the 401 response was for an expired token. Otherwise redirect
        // the user to the login page
        if (
            !initialResponse.headers
                .get('www-authenticate')!
                .includes('error_description="The token is expired"')
        ) {
            kickToLogin();
        }

        if (!tokenRefreshPromise) {
            tokenRefreshPromise = refreshJwt();
        }

        await tokenRefreshPromise;
        return fetch(updateRequestAuth(request));
    }
    return Promise.resolve(initialResponse);
}

function checkStatus(response: Response): Promise<Response> {
    if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response);
    } else if (response.status === 403) {
        throw new Error('This action not authorized (403).');
    } else if (response.status === 404) {
        throw new Error('Action not found (404).');
    } else {
        throw new Error(response.statusText || `Failed to complete request (${response.status}).`);
    }
}

export function parseJSON<T>(response: Response): Promise<T | undefined> {
    if (response.status !== 204) {
        return response.json() as Promise<T>;
    } else {
        return Promise.resolve(undefined);
    }
}

export function httpRequest<T>(
    requestUrl: string,
    method: string = 'get',
    body?: any,
    leaveBody?: boolean
): Promise<ApiResult<T>> {
    let request = buildRequest(requestUrl, method, body, leaveBody);

    return fetch(request.clone())
        .then(response => checkTokenExpiration(request, response))
        .then(response => checkStatus(response))
        .then(response => parseJSON<ApiResult<T>>(response))
        .then(data => {
            if (data === undefined) {
                return {
                    success: false,
                    error: 'No data received from server'
                };
            }
            return data;
        })
        .catch(error => {
            logAppInsightsException(
                `API Request Error while making ${method} request to ${requestUrl} with body ${body}: ${error}`,
                'Server Request'
            );
            return {
                success: false,
                error: 'Request to server failed. Please refresh the page and try again.'
            };
        });
}

export function httpFileRequest<T>(
    requestUrl: string,
    method: string = 'get',
    body?: any,
    leaveBody?: boolean
): Promise<ApiResult<T>> {
    let request = buildFileRequest(requestUrl, method, body, leaveBody);

    return fetch(request.clone())
        .then(response => checkTokenExpiration(request, response))
        .then(response => checkStatus(response))
        .then(response => parseJSON<ApiResult<T>>(response))
        .then(data => {
            if (data === undefined) {
                return {
                    success: false,
                    error: 'No data received from server'
                };
            }
            return data;
        })
        .catch(error => {
            logAppInsightsException(
                `API Request Error while making ${method} request to ${requestUrl} with body ${body}: ${error}`,
                'Server Request'
            );
            return {
                success: false,
                error: 'Request to server failed. Please refresh the page and try again.'
            };
        });
}

function buildFileRequest(
    requestUrl: string,
    method: string = 'get',
    body?: any,
    leaveBody?: boolean
): Request {
    let headers: Headers = new Headers();

    //headers.append('Accept', 'application/json');
    if (identity.isAuthenticated()) {
        headers.append('Authorization', `Bearer ${identity.getJwt()}`);
    }

    let content: any;

    if (leaveBody && body !== undefined) {
        content = body;
    } else if (body !== undefined) {
        content = body;
        headers.append('Content-Type', 'multipart/form-data');
    }

    return new Request(requestUrl, {
        method: method,
        body: content,
        headers: headers
    });
}


// WEBPACK FOOTER //
// ./src/api/Shared.ts